import $ from 'jquery';
import 'ion-rangeslider';

// load
$(window).on('load', () => {
  const preloader = $('#loader');
  const loader = preloader.find('.spinner');
  loader.fadeOut();
  preloader.delay(350).fadeOut('slow');
  $('body').removeClass('js-loading');


  $('.start-anim').addClass('anim');
});


$(document).scroll(() => {
  const WinTop = $(window).scrollTop();
  const docHeight = $(window).height();

  $('.fadeEl').each(function () {
    const topIn = $(this).offset().top - docHeight * 0.80;
    if (WinTop > topIn) {
      $(this).addClass('anim');
    }
  });

  $('.animation').each(function () {
    const topIn = $(this).offset().top - docHeight * 0.80;
    if (WinTop > topIn) {
      $(this).addClass('start-animation');
    }
  });
});


$(() => {
  let $el; let leftPos; let newWidth;
  const $mainNav = $('.header_top .hover_line');

  /*
        menu top
    */
  $mainNav.append("<li class='h-line'></li>");

  const $magicLine = $('.header_top .h-line');

  $magicLine
    .width($('.header_top .active').width())
    .css('left', $('.hover_line .active a').position().left)
    .data('origLeft', $magicLine.position().left)
    .data('origWidth', $magicLine.width());

  $('.header_top .hover_line li').find('a').hover(function () {
    $el = $(this);
    leftPos = $el.position().left;
    newWidth = $el.parent().width();

    $magicLine.stop().animate({
      left: leftPos,
      width: newWidth,
    });
  }, () => {
    $magicLine.stop().animate({
      left: $magicLine.data('origLeft'),
      width: $magicLine.data('origWidth'),
    });
  });

  $(window).click((e) => {
    if (!$(e.target).closest('#header_compare').length) {
      $('#header_compare').removeClass('show');
      $('#main').removeClass('show-compare');
    }
  });
  $('#header_compare .compare_show').click(() => {
    $('#header_compare').toggleClass('show');
    $('#main').toggleClass('show-compare');

    // $('#header_compare .compare-block').on('mouseenter', () => {
    //   $('#header_compare').addClass('show');
    //   $('#main').addClass('show-compare');
    // }).on('mouseleave', () => {
    //   function hidemessage() {
    //     $('#header_compare').removeClass('show');
    //     $('#main').removeClass('show-compare');
    //   }
    //   setTimeout(hidemessage, 1200);
    // });
  });
  // $('#header_compare .compare-block').click((event) => {
  //   event.stopPropagation();
  // });

  $('#header_compare.show .compare_show').click(() => {
    $('#header_compare').toggleClass('show');
    $('#main').removeClass('show-compare');
  });

  $('.navigation-menu > li').hover(function () {
    $('.navigation-menu > li').removeClass('active');
    $(this).addClass('active');
  });

  $('.search .show-search').click(function () {
    $(this).parents('.search').toggleClass('show');
    $('#main').toggleClass('show-search');

    // $('.search.show .search-panel').on('mouseenter', () => {
    //   $('.search').addClass('show');
    //   $('#main').addClass('show-search');
    // }).on('mouseleave', () => {
    //   function hides() {
    //     $('.search').removeClass('show');
    //     $('#main').removeClass('show-search');
    //   }
    //   setTimeout(hides, 1200);
    // });
  });
  // $('.search .show-search').click(() => {
  //   $(this).parents('.search').toggleClass('show');
  //   $('#main').toggleClass('show-search');
  // });
  $(window).click((e) => {
    if (!$(e.target).closest('.search.show').length) {
      $('.search').removeClass('show');
      $('#main').removeClass('show-search');
    }
  });

  if (window.innerWidth <= 820) {
    $('.footer-menu').addClass('m_accordion-item');
    $('.footer-menu .tit').addClass('m_accordion-tit');
    $('.footer-menu ul').addClass('m_accordion-panel');
  }

  $('#adaptive_menu .menu-show').click(() => {
    $('#adaptive_menu').addClass('open');
    $('#main').addClass('ov-hidden');
  });
  $('#adaptive_menu .menu-hide').click(() => {
    $('#adaptive_menu').removeClass('open');
    $('#main').removeClass('ov-hidden');
  });

  $('#adaptive_menu .close-menu').click(() => {
    $('#adaptive_menu').removeClass('open');
    $('#main').removeClass('ov-hidden');
  });

  $('.m_accordion-tit').on('click', function (e) {
    e.preventDefault();
    if ($(this).closest('.m_accordion-item').hasClass('active')) {
      $('.m_accordion-item').removeClass('active');
    } else {
      $('.m_accordion-item').removeClass('active');
      $(this).closest('.m_accordion-item').addClass('active');
    }
    const $content = $(this).next();
    $content.slideToggle(500);
    $('.m_accordion-item .m_accordion-panel').not($content).slideUp('slow');
  });

  $('#adaptive_menu .mpanel_link').click(function () {
    $(this).parents('.mpanel').addClass('open');
  });

  $('#adaptive_menu .mpanel .mpanel-back').click(() => {
    $('.mpanel').removeClass('open');
  });

  const wmenu = $('#navigation').width();

  if (wmenu > 1140) {
    $('#navigation').addClass('mmore');
  }

  $('#useful-articles .filter-item').click(function () {
    $('#useful-articles .filter-item').removeClass('active');
    $(this).addClass('active');

    const idfilter = $(this).data('id');
    $('#useful-articles').attr('data-filter', idfilter);

    $('#useful-articles .filter-item').removeClass('active');
    $(`#useful-articles .filter-item[data-id='${idfilter}']`).addClass('active');
  });

  $('.selectpicker').selectpicker({
    noneResultsText: 'Ничего не найдено',
  });

});
